export default "__VITE_ASSET__KZk_oY_6__"